import { render, staticRenderFns } from "./StatisticsTab.vue?vue&type=template&id=3ae1728c&scoped=true&"
import script from "./StatisticsTab.vue?vue&type=script&lang=js&"
export * from "./StatisticsTab.vue?vue&type=script&lang=js&"
import style0 from "./StatisticsTab.vue?vue&type=style&index=0&id=3ae1728c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ae1728c",
  null
  
)

export default component.exports